import styled from 'styled-components';
export const TabWrapperStyled = styled.div `
  display: grid;
  grid-template-columns: repeat(${({ tabs }) => tabs.length}, 1fr);
  gap: 12px;
  grid-template-rows: 1fr;
  width: ${({ width }) => width || '100%'};
`;
export const TabItemStyled = styled.button `
  border: 0px;
  border-radius: 6px;

  ${({ currentTab, label, theme: { colors } }) => {
    if (currentTab === label) {
        return `
        background-color: #e3edf7;
        box-shadow: 4px 4px 14px 0px #D9D9D9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.60) inset;
        background: linear-gradient(270deg, ${colors.blue500} 0%, ${colors.blue500} 39.9%, ${colors.lightBlue500} 100%), ${colors.gray100};
        -webkit-background-clip: text, padding-box;
        background-clip: text, padding-box;
        -webkit-text-fill-color: transparent;

        @-moz-document url-prefix() {
            -webkit-text-fill-color: unset;
            background-clip: unset;
            background: #FFF;
            background-color: #FFF;
            color: ${colors.blue500};
          }
      `;
    }
    return `
    color: ${colors.gray700};
    background: transparent;
    `;
}}

  ${({ theme: { typography }, label, currentTab }) => currentTab === label ? typography.bodyMedium3 : typography.body3}

  ${({ size }) => {
    switch (size) {
        case 'large':
            return `
        padding: 10px;
        min-height: 34px;
        `;
        default:
            return `        
        min-height: 38px;
        padding: 8px;
        `;
    }
}}
`;
//# sourceMappingURL=styled.js.map